<template>
    <section>
        <div class="row justify-content-end">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'tryout/online/index' }">
                                Tryout
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'tryout/online/view', params: {id: tryout.id} }">
                                {{ tryout.name }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'tryout/online/question/view', params: {id: tryout.id, tryoutSubjectID: tryoutSubject.id} }">
                                {{ tryoutSubject.subject.name }} {{ tryoutSubject.code }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            Add Package
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <h3>Tryout Online {{ tryout.name }} - {{ tryoutSubject.subject.name }} {{ tryoutSubject.code }}</h3>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12 order-sm-2">
                <div class="card shadow-sm mb-4 border-0">
                    <div class="card-header background-primary">
                        <div class="row justify-content-end">
                            <div class="col">
                                <span class="h4 font-weight-medium text-white mb-0">
                                    Buat Paket Soal
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <form v-on:submit.prevent="save">
                            <div class="form-group">
                                <label class="font-weight-medium required">Jumlah Paket Soal</label>
                                <div class="row">
                                    <div class="col-xl-3 col-md-4 col-6">
                                        <input v-model.number="form.quantity" class="form-control form-control-sm" type="number" min="1" placeholder="Jumlah" required />
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="font-weight-medium mb-0">Range Nomor Soal</label>
                                <small class="font-weight-medium form-text font-italic mb-2">Silahkan masukkan kelompok-kelompok nomor soal yang tidak dapat dipisah, seperti soal cerita</small>
                                <div class="row">
                                    <div class="col-xl-6 col-md-8 col-12">
                                        <template v-for="(group, index) in form.groups">
                                            <div class="row mb-2">
                                                <div class="col pr-1">
                                                    <input v-model.number="group.start" class="form-control form-control-sm" type="number" min="1" v-bind:max="tryoutSubject.totalQuestion" placeholder="No. Awal" required />
                                                </div>
                                                <div class="col-auto px-1">
                                                    <i class="fa fa-minus"></i>
                                                </div>
                                                <div class="col px-1">
                                                    <input v-model.number="group.end" class="form-control form-control-sm" type="number" v-bind:min="group.start + 1" v-bind:max="tryoutSubject.totalQuestion" placeholder="No. Akhir" required />
                                                </div>
                                                <div class="col-auto pl-1 text-center">
                                                    <a href="#" v-if="form.groups.length > 0" v-on:click.prevent="removeGroup(index)">
                                                        <i class="fa fa-times text-danger"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                                <button class="btn btn-link btn-sm px-0" type="button" v-on:click="addGroup()">
                                    + Tambah Range Nomor Soal
                                </button>
                            </div>
                            <div class="form-group">
                                <button type="submit" class="btn btn-danger btn-sm px-4">
                                    Generate
                                </button>
                                <router-link v-bind:to="{ name: 'tryout/online/question/view', params: {id: tryout.id, tryoutSubjectID: tryoutSubject.id} }" exact class="btn btn-outline-danger btn-sm px-4 ml-2">
                                    Cancel
                                </router-link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-12 order-sm-1">
                <div class="card shadow-sm mb-4 border-0" v-for="(question, index) in questions" v-bind:key="question.order">
                    <div class="card-header background-primary">
                        <div class="row justify-content-end">
                            <div class="col">
                                <span class="h4 font-weight-medium text-white mb-0">
                                    Soal No. {{ question.order }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row mb-3">
                            <div class="col font-weight-bold">
                                Deskripsi Soal
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col" v-html="question.content"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12 mb-4">
                <nav class="float-right">
                    <paginate v-model="page" next-text="<i class='fa fa-chevron-right'></i>" prev-text="<i class='fa fa-chevron-left'></i>" v-bind:click-handler="paginate" v-bind:page-count="pageCount" container-class="pagination pagination-sm flex-wrap" page-class="page-item" prev-class="page-item" v-bind:next-class="'page-item'" page-link-class="page-link" prev-link-class="page-link" next-link-class="page-link" v-bind:hide-prev-next="true">
                    </paginate>
                </nav>
            </div>
        </div>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import Paginate from 'vuejs-paginate';

    /**
     * @param {Object} tryoutSubject
     */
    export default {
        name: "TryoutOnlineQuestionPackageAdd",
        components: {
            Paginate
        },
        computed: mapState([
            'profile'
        ]),
        data() {
            return {
                form: {
                    quantity: 1,
                    groups: []
                },
                tryout: {},
                tryoutSubject: {subject: {}},
                questions: [],
                pageCount: 0,
                page: 1,
                perPage: 5
            };
        },
        methods: {
            save() {
                this.axios.post(process.env.API_URL + '/tryout/create-package', Object.assign({}, this.form, {tryoutSubjectID: this.tryoutSubject.id})).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.$router.push({name: 'tryout/online/question/view', params: {id: this.tryout.id, tryoutSubjectID: this.tryoutSubject.id}});
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            addGroup() {
                this.form.groups.push({
                    start: '',
                    end: ''
                });
            },
            removeGroup(index) {
                this.form.groups.splice(index, 1);
            },
            generateOrder(index) {
                return index + 1 + ((this.page - 1) * this.perPage);
            },
            paginate(page) {
                this.axios.get(process.env.API_URL + '/question', {params: {tryoutSubjectID: this.tryoutSubject.id, page: page, limit: this.perPage}}).then(response => {
                    let questions = [];
                    for (let i = 0; i < this.perPage; i++) {
                        let number = this.generateOrder(i);
                        if (number <= this.tryoutSubject.totalQuestion) {
                            questions.push(response.data.data.find(question => question.order === number) || {order: number, choices: []});
                        }
                    }
                    this.questions = questions;
                });
            },
            roleElligibleModified() {
                return this.profile.isAdmin;
            }
        },
        created() {
            this.axios.get(process.env.API_URL + '/tryout/' + this.$route.params.id).then(response => {
                this.tryout = response.data.data;
                if (!this.tryout.tryoutOnline) {
                    this.$router.replace({name: 'error', params: {code: 404, message: 'Tryout online not found'}});
                }
                if (this.tryout.tryoutGroups.length) {
                    for (var i = 0; i < this.tryout.tryoutGroups.length; i++) {
                        this.tryoutSubject = this.tryout.tryoutGroups[i].tryoutSubjects.find(tryoutSubject => tryoutSubject.id === parseInt(this.$route.params.tryoutSubjectID));
                        if (this.tryoutSubject) {
                            break;
                        }
                    }
                } else {
                    this.tryoutSubject = this.tryout.tryoutSubjects.find(tryoutSubject => tryoutSubject.id === parseInt(this.$route.params.tryoutSubjectID));
                }
                if (!this.tryoutSubject) {
                    this.$router.replace({name: 'error', params: {code: 404, message: 'Subject Not found'}});
                }
                this.pageCount = Math.ceil(this.tryoutSubject.totalQuestion / this.perPage);

                this.paginate(this.page);
                document.title = 'Tryout Online ' + this.tryout.name + ' - ' + this.tryoutSubject.subject.name + ' ' + this.tryoutSubject.code + ' Add Package- ' + process.env.APP_NAME;
            }).catch((error) => {
                this.$router.replace({name: 'error', params: {code: error.response.status, message: error.response.statusText}});
            });

        }
    };
</script>


// WEBPACK FOOTER //
// src/components/tryout/online/question/package/Add.vue